export default __webpack_public_path__ + "static/media/quotes.3da86df5.svg";